module.exports = require("firefox-profile");


//////////////////
// WEBPACK FOOTER
// external "firefox-profile"
// module id = 171
// module chunks = 0